module.exports = __webpack_public_path__ + "img/park_1.ce72b8d2.jpg";